import { mainApiAxios as axios } from '@/plugins/axios'


export default {

    listDictionary() {
        return axios.get('dictionary')
    },

    updateDictionary(dictionaryId, dictionaryObj) {
        return axios.post(`dictionary/update/${dictionaryId}`, dictionaryObj)
    },

    addDictionary(dictionaryObj) {
        return axios.post('dictionary', dictionaryObj)
    },

    // the API exposes this as POST api/dictionary/delete/{id} - the "delete/" segment
    // was missing here, so every request 404'd before reaching the controller
    deleteDictionary(dictionaryId) {
        return axios.post(`dictionary/delete/${dictionaryId}`)
    }
}